import { Tab as ReactTab, Tabs as TabsReact, TabList, TabPanel } from 'react-tabs';
import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const List = styled(TabList)`
  display: flex;
  justify-content: space-around;
`;

const Tabs = styled(TabsReact)`
  box-sizing: border-box;

  border: 0.1rem solid ${pickColor('tabBorder')};
`;

const Tab = styled(ReactTab)`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 100%;
  height: 5rem;
  padding: 1.3rem 2rem;

  box-sizing: border-box;

  font-family: 'LFT Zeno Condensed';
  font-size: 1.6rem;
  font-weight: bold;

  text-transform: uppercase;
  text-align: center;

  border-left: 0.1rem solid ${pickColor('tabBorder')};
  border-right: 0.1rem solid ${pickColor('tabBorder')};
  border-bottom: 0.1rem solid
    ${({ selected }) => (selected ? 'transparent' : pickColor('tabBorder'))};
  border-top: 0.1rem solid
    ${({ selected }) => (selected ? pickColor('tabBorder') : 'transparent')};
  color: ${({ selected }) => (selected ? pickColor('black') : pickColor('restTabText'))};
  background-color: ${({ selected }) =>
    selected ? pickColor('white') : pickColor('restTabBackground')};

  cursor: pointer;
  transition: 0.1s border ease-in;

  &:hover {
    ${({ selected, disabled }) =>
      !selected &&
      !disabled &&
      css`
        color: ${pickColor('colmarBlue')};
        border: 0.1rem solid ${pickColor('colmarBlue')};
        background-color: ${pickColor('tabHoverBackground')};
      `}
  }

  &:focus {
    outline: none;
  }

  &:first-of-type {
    border-left: 0.1rem solid transparent;

    &:hover {
      ${({ selected, disabled }) =>
        !selected &&
        !disabled &&
        css`
          border-left: 0.2rem solid ${pickColor('colmarBlue')};
        `}
    }
  }

  &:last-of-type {
    border-right: 0.2rem solid transparent;

    &:hover {
      ${({ selected, disabled }) =>
        !selected &&
        !disabled &&
        css`
          border-right: 0.2rem solid ${pickColor('colmarBlue')};
        `}
    }
  }
`;

const Panel = styled(TabPanel)`
  display: ${({ selected }) => (!selected ? 'none' : 'block')};

  padding: 0.2rem;

  background-color: ${pickColor('white')};
`;

export { Tabs, List, Tab, Panel };
